<template lang="pug">
  v-container.pa-0(fluid)
    v-card
      v-card-title {{ $t('bankTransactionPage.newTransaction') }}
      v-card-text.title {{getTitle}}
        v-container.pa-0
          v-tabs
            v-tab {{ $t('bankTransactionPage.propertiesTabLabel') }}
            v-tab {{ $t('bankTransactionPage.amountToWalletTabLabel') }}

            v-tab-item
              BankTransactionPropertiesTab( v-if="newTransaction" :transactionDetail="newTransaction" )
            v-tab-item
              BankTransactionAmountToWalletTab( v-if="newTransaction" :transactionDetail="newTransaction")
      v-divider
      v-card-actions
        v-spacer
        v-btn(color="primary"  @click="onSubmitButtonClick")  {{ $t('bankTransactionPage.finishButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop,} from 'vue-property-decorator'
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import TransactionInvoice from "@/model/BankTransaction/TransactionInvoice";
import moment from "moment/moment";
import BankTransactionPropertiesTab from "@/components/user/BankTransactionPropertiesTab.vue";
import BankTransactionAmountToWalletTab from "@/components/user/BankTransactionAmountToWalletTab.vue";

@Component({
  components: {
    BankTransactionPropertiesTab,
    BankTransactionAmountToWalletTab
  },
})
export default class ControlDialog extends Vue {
  @Prop({ type: Object, required: false}) readonly newTransaction!: BankTransaction

  get getTitle (): string {
    if(this.newTransaction.boarder && this.newTransaction.boarder.person && this.newTransaction.boarder.person.firstName && this.newTransaction.boarder.person.familyName) {
      return `${this.newTransaction.boarder.person.firstName} ${this.newTransaction.boarder.person.familyName}`
    } else {
      return ''
    }
  }

  getCredit (item: TransactionInvoice) {
    if(item){
      return item.invoice.amountFromWallet / 100
    }
  }

  getInvoices (item: number) {
    if(item){
      return (item / 100).toFixed(2)
    } else {
      return 0
    }
  }

  getFormattedDate (item: string): string {
    return moment(item).format('D.M.YYYY')
  }

  onSubmitButtonClick () {
    this.$emit('complete')
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>
.style
  color: green
</style>
